import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("Credits/api/DetailsAccountsQuery").then(r => {
        commit("setList", r.data.data);
      });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("Credits/api/DetailsAccounts", model).then(() => {
      });
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "Credits/api/DetailsAccounts",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {
          dispatch("fetch");
        });
    },
    update({ commit, dispatch }, model) {
      return ajax.put("Credits/api/DetailsAccounts", model).then(() => {
        dispatch("fetch");
      });
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
